/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
//Si se modifica, cambiar tambien en PlanesCardContainer.vue
const DESCUENTO_0KM_ESPECIALES_PACK_COMODO = 50;
const DESCUENTO_0KM_ESPECIALES_PACK_AHORRO = 20;
const DESCUENTO_0KM_OTROS_PACK_COMODO = 30;
const DESCUENTO_0KM_OTROS_PACK_AHORRO = 15;
const DESCUENTO_USADOS = 10;

const legales = `
<b>Legales</b>
</br><strong>
      ¿Hasta cuándo podés beneficiarte de esta promoción?</strong></br>
          Esta promoción es válida para la República Argentina, con excepción de la ciudad de Rosario, provincia de Santa Fe (TERRITORIO), hasta el 30 de Septiembre de 2026, inclusive.</br>
        

        <strong>¿En qué consiste la promoción?</strong></br>
       
          Todo Cliente de Banco BBVA Argentina S.A. (BBVA) que contrate un NUEVO Seguro de auto de Caja de Seguros S.A. (La Caja),
      <br/><br/>•Para los siguientes vehículos 0km.: Fiat Cronos - Ford Ranger/Territory – Toyota Hilux (no SW4)/Corolla/Corolla Cross/Yaris - Peugeot 208/2008 - Renault Kangoo - VW Amarok - BYD Yuan Pro/Dolphin/Song/Shark/Atto - BAIC BJ30/BJ40/BJ60/X 35/X 55/U5/EU5 4P, con coberturas:
        <br/>-Todo Riesgo y Terceros Completos con y sin granizo correspondiente a Pack Cómodo, será beneficiado con un 50% de descuento sobre la prima* en las 3 primeras cuotas *, ó
          <br/>-Todo Riesgo y Terceros Completos con y sin granizo correspondiente a Pack Ahorro, podrá beneficiarse con un 20% de descuento sobre la prima* en las 3 primeras cuotas *.        

        <br/><br/>•Para el resto de vehículos 0km.:
        <br/>-Todo Riesgo y Terceros Completos con y sin granizo correspondiente a Pack Cómodo, será beneficiado con un 30% de descuento sobre la prima* en las 3 primeras cuotas *, ó
        <br/>-Todo Riesgo y Terceros Completos con y sin granizo correspondiente a Pack Ahorro, podrá beneficiarse con un 15% de descuento sobre la prima en las 3 primeras cuotas.
      
      <br/>Concluídos esos plazos, se aplicará un beneficio adicional con la intención de normalizar gradualmente el precio, teniendo en cuenta el contexto inflacionario actual.

        <br/><br/>•Para vehículos usados, exclusivamente con hasta 10 años de antigüedad (año actual + 10):
      <br/>-Todo Riesgo y Terceros Completos de ambos Pack, será beneficiado con un 30% de descuento sobre la prima* en las 3 primeras cuotas.
      
      <br/><br/>•Para vehículos usados, exclusivamente entre 11 y hasta 15 años de antigüedad:
      <br/>-Todo Riesgo y Terceros completo de ambos Pack, será beneficiando con un 20% de descuento sobre la prima* en las 3 primeras cuotas.
      
      <br/><br/><strong
          >¿Qué requisitos debés cumplir para poder acceder a cada promoción?</strong
        >
        <br/>•Ser Cliente de BBVA.
          <br/>•Pagar exclusivamente mediante tarjeta de crédito o cuenta bancaria de BBVA.
          <br/>•Contratar el/los Seguro/s en cualquier Sucursal de BBVA, a través del 0810-999-0202, ó ingresando a Banca Online en <a href="https://www.bbva.com.ar" target="_blank">www.bbva.com.ar</a>, ó a través de la APP móvil BBVA.
          <br/>•Que sea un seguro nuevo (que el cliente no lo tuviera asegurado en Caja previamente).
        </br>

        <br/><strong>¿Cómo se aplican los descuentos?</strong>
        <br/>•En oportunidad de la cotización, se muestran los planes y costos que se podrán otorgar.
      <br/>•A fin de validar la aplicación de LA PROMO para el vehículo, será importante informar la patente del mismo ya que, en caso de NO hacerlo, se mostrará LA PROMO corresponda o no.
          <br/>•Una vez que decidas tomar la/las cobertura/s y que se procesa el alta (emisión), en el frente de Póliza se indicará la cuota del Seguro con el descuento (de corresponder) de acuerdo a la cobertura optada, incluido.</br>
        
        
        <br/><strong>¿Qué otra información importante debés tener en cuenta?</strong
        >
        <br/>•Esta promoción no es combinable, canjeable por dinero ni tampoco acumulable con otras promociones.
            <br/>•Bonificación no aplicable a aquellos clientes que i) hayan contratado la Póliza de Auto con anterioridad a la fecha de inicio de vigencia de LA PROMO; ii) hayan contratado una Póliza de Auto y hubieran dado de baja la misma dentro de los 30 días contados desde el inicio de vigencia de LA PROMO.
      <br/>•Organizador: Caja de Seguros S.A.
        </br></br>
          Los seguros son emitidos en coaseguro por Caja de Seguros S.A. Fitz Roy 957 (C1414CHI) Ciudad Autónoma de Buenos Aires - Argentina CUIT 30-66320562-1.- N° de inscripción en SSN: 0501, y BBVA Seguros., Av. Córdoba 111, Piso 22, C1054AAA, C.A.B.A. CUIT 30-50006423-0 .N° de inscripción en SSN: 0396. Agente Institorio Banco BBVA Argentina S.A., Av. Córdoba 111, Piso 31, C1054AAA, CABA. CUIT 30-50000319-3.- N° de inscripción en SSN: 0135. Superintendencia de Seguros de la Nación 0-800-666-8400 | <a href="https://www.ssn.gob.ar" target="_blank">www.ssn.gob.ar</a>`;

export default {
  googleAnalyticsId: "UA-XXXXAAAA1111-1",
  modulo: "Seguro de auto",
  cantPasos: 8,
  descuentos: {
    descuento_0km_especiales_comodo: DESCUENTO_0KM_ESPECIALES_PACK_COMODO,
    descuento_0km_especiales_ahorro: DESCUENTO_0KM_ESPECIALES_PACK_AHORRO,
    descuento_0km_otros_comodo: DESCUENTO_0KM_OTROS_PACK_COMODO,
    descuento_0km_otros_ahorro: DESCUENTO_0KM_OTROS_PACK_AHORRO,
    descuento_usados: DESCUENTO_USADOS
  },
  pasos: {
    paso1: {
      path: "/",
      paso: 1,
      component: "views/common/Paso1",
      titulo: "Cotizá el seguro de tu auto 100% online",
      subtitulo:
        "Te solicitamos este dato para saber si sos cliente y poder cotizar tu seguro. ",
      imgdeco: require("@/assets/img/ProductsandServicesCar.png"),
      imgdecoMobile: require("@/assets/img/ProductsandServicesCar.png"),
      footerText: null,
      pasoSiguiente: "paso2"
    },
    paso2: {
      path: "/paso2",
      component: "views/auto/Paso2",
      paso: 2,
      pasoSiguiente: "condicion",
      titulo: "¡Encontrá el seguro ideal de tu auto en BBVA!",
      subtitulo:
        "Te pediremos los siguientes datos para poder cotizar tu seguro."
    },
    condicion: {
      path: "/condicion",
      component: "views/auto/Condicion",
      paso: 3,
      titulo: "¿Cuál es la condición de tu auto?",
      titulo_mobile: "¿De qué año es tu auto?",
      card_text:
        "Si tu auto es usado, podremos pedirte una revisión después de que lo asegures."
    },
    marca: {
      path: "/marca",
      component: "views/auto/Marca",
      paso: 4,
      titulo: "¿Cuál es la marca de tu auto?"
    },
    modelo: {
      path: "/modelo",
      component: "views/auto/Modelo",
      paso: 5,
      titulo: "¿Cuál es el modelo de tu auto?"
    },
    version: {
      path: "/version",
      component: "views/auto/Version",
      paso: 6,
      titulo: "¿Cuál es la versión de tu auto?"
    },
    gnc: {
      path: "/gnc",
      component: "views/auto/GNC",
      paso: 7,
      titulo: "¿Tu auto tiene equipo de GNC?"
    },
    guardado: {
      path: "/guardado",
      component: "views/auto/Guardado",
      paso: 8,
      titulo: "¿Dónde guardás o vas a guardar tu auto?",
      card_text:
        "Esta información influye en el precio de la cotización de tu seguro."
    },
    resumen: {
      path: "/resumen",
      component: "views/auto/Resumen",
      paso: 7,
      titulo: "¿Son correctos estos datos?",
      subtitulo:
        "Verificá los datos encontrados para la patente ingresada, si encontrás que alguno es incorrecto podés modificarlo."
    },
    cotizacion_planes: {
      path: "/planes",
      component: "views/auto/CotizacionPlanes",
      titulo: "¡Estas son las coberturas que tenemos para vos!",
      subtitulo:
        "Seleccioná la que más se adapate a tus necesidades y finalizá la contratación ingresando a Banca Online",
      footerPlanesText: legales,
      help:
        "<p><b>¿Qué es la franquicia?</b></p>" +
        "<p>Es el monto de dinero que pagás por el arreglo de tu auto en caso de un siniestro con daños parciales.</p>" +
        "<p><b>¿Cómo funciona?</b></p>" +
        "<p>Si tu auto sufre un daño parcial, vos solo pagás la franquicia, que es un porcentaje de la suma asegurada. El resto del arreglo lo cubre el seguro.</p>" +
        "<p>Por ejemplo, en el caso que elijas una franquicia variable del 10%, si la suma asegurada del auto es de $20.000.000, y el costo de reparación del auto es de $2.000.000, vos pagás $200.000 y la Compañía te cubre el resto: $1.800.000</p>" +
        '<p style="text-align: right;font-family: BentonSansBBVA-Medium;font-size: 15px;"></p>'
    },
    gracias: {
      path: "/gracias",
      component: "views/auto/Gracias"
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/common/Mensaje"
    },
    loading: {
      path: "/loading/:mje",
      component: "views/common/Verificacion"
    }
  }
};
